export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore()
  const { cannot } = useRolePermissions()

  // === Autenticación ===
  // Si no hay ningún token (ni access ni refresh), redirigir a login
  if (!authStore.accessToken && !authStore.refreshToken) {
    return navigateTo('/login')
  }

  // Si hay refreshToken válido, permitir navegación
  // (el plugin o useApi se encargarán del refresh si es necesario)
  if (authStore.refreshToken && !authStore.isRefreshTokenExpired) {
    // Continuar para verificar permisos
  } else if (authStore.isAccessTokenExpired) {
    // Si el access token expiró y no hay refresh token válido, redirigir a login
    return navigateTo('/login')
  }

  // === Detectar promoción activa ===
  // Si la ruta contiene un ID de promoción, establecerlo como activo
  const promotionId = to.params.id
  if (promotionId && to.path.startsWith('/promotions/')) {
    authStore.setActivePromotion(promotionId)
  } else if (authStore.activePromotionId) {
    // Si no estamos en una ruta de promoción, limpiar la promoción activa
    authStore.setActivePromotion(null)
  }

  // === Permisos ===
  const routePermission = to.meta.permission
  if (routePermission) {
    const [action, subject] = routePermission
    if (cannot(action, subject)) {
      return navigateTo('/forbidden')
    }
  }
})
